import { Controller } from "@hotwired/stimulus";
import RequestHelper from "../helpers/request_helper";
import DesignUploaderHelper from "../helpers/design_uploader_helper";

// The checkout step. It shares two behaviours with give_redemption_controller.js, both reached
// through the shared helpers rather than duplicated:
//   - showNewUpload/hideNewUpload, reached from gives/polaroids/new.html.haml's "Upload New
//     Image"/"Back" inside this page's edit-image modal, via DesignUploaderHelper.
//   - the upload change-listener, armed in connect() via DesignUploaderHelper. The my-library
//     tab navigation is a Turbo frame now, driven by the frame itself.
//
// The redemption page's own behaviour - hero image drag/resize, the slick carousel, the banner
// modals - touches DOM this page's preview column never renders, so none of it lives here.
export default class extends Controller {
  connect() {
    this.$form = $(this.element).find("form#giving-form");
    this.debouncedUpdateCard = _.debounce((fn) => fn(), 350);

    DesignUploaderHelper.initialize();

    // turbo:frame-load is the pjax:end equivalent. Delegated off this.element and filtered by
    // id rather than bound to a frame captured here: the frame can be absent at connect() on
    // one of the two build variants, and a captured reference would silently never fire (P8).
    this.onDesignFrameLoad = this.onDesignFrameLoad.bind(this);
    this.element.addEventListener("turbo:frame-load", this.onDesignFrameLoad);
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.onDesignFrameLoad);
  }

  onDesignFrameLoad(event) {
    if (event.target.id !== "give-frame") { return; }

    $.smoothScroll({ scrollTarget: "#give-frame", offset: -200 });
  }

  toggleEditRedemptionImageModal(event) {
    const forceClosing = event?.params?.forceClosing || false;
    const element = document.querySelector(".edit-redemption-image-modal");

    if (forceClosing) {
      element.classList.remove("show");
    } else {
      element.classList.toggle("show");
    }
  }

  nextStep(e) {
    e.preventDefault();
    $(this.element).find("form#giving-form").submit();
  }

  toggleEnhancementsContent(e) {
    e.preventDefault();
    $(this.element).find(".enhancements-column .content").toggleClass("closed");
    $(this.element).find(".enhancements-list-toggler i").toggleClass("icon-lasso-chevron-up");
  }

  previewRedemption(e) {
    e.preventDefault();
    const originalBtn = $(this.element).find(".btn-preview-redemption")[0];
    originalBtn.click();
  }

  previewEmail(e) {
    e.preventDefault();
    const originalBtn = $(this.element).find(".btn-preview-email")[0];
    originalBtn.click();
  }

  updateCard(e) {
    const attr = e.params.attr;

    this.debouncedUpdateCard(() => {
      const path = this.$form.attr("action");
      const options = RequestHelper.defaultPatchOptions();
      options.headers = Object.assign({}, options.headers, { "Content-Type": "application/json" });
      options.body = JSON.stringify({ build: { [attr]: e.target.value } });

      fetch(path, options).then((response) => {
        if (!response.ok) { console.warn(response); }
      }).catch((error) => console.warn(error));
    });
  }

  toggleAvailableForTeams(e) {
    const isChecked = e.target.checked;
    $(this.element).find("#save-gift-template-form input[name='gift_template[available_for_teams]']").val(isChecked);
  }

  showNewUpload() {
    DesignUploaderHelper.showNewUpload($(window).width() < 768);
  }

  hideNewUpload() {
    DesignUploaderHelper.hideNewUpload();
  }
}
